<div class="att-dialog-card">
  <div class="att-dialog-header">
    <h5 class="att-dialog-title">Select Attendance Details</h5>
    <button type="button" class="att-dialog-close" (click)="cancel()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="att-dialog-body">
    <div class="att-dialog-form">
      <div class="att-dialog-field">
        <label class="att-dialog-label">Date</label>
        <div class="date-picker-container">
          <input matInput [matDatepicker]="picker" placeholder="DD-MM-YYYY" class="form-control att-dialog-input"
            [(ngModel)]="attendanceDate" [max]="maxDate" />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">Study Class</label>
        <div class="dropdown w-100">
          <button class="att-dialog-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="dropdown-text">{{ selectedStudyClassName || 'Select Study Class' }}</span>
          </button>
          <ul class="dropdown-menu w-100 att-dialog-dropdown-menu">
            <li class="att-search-container">
              <input type="text" class="form-control att-search-input" placeholder="Search Study Class"
                [(ngModel)]="studyClassQuery" (keyup)="filterStudyClasses()" />
            </li>
            <li class="list_campus">
              <ng-container *ngFor="let cls of filteredStudyClassList">
                <ul class="att-dropdown-item" (click)="selectStudyClass(cls)"
                  [class.att-item-selected]="selectedStudyClassId === cls.id">
                  <li class="att-item-text">{{ cls.studyClass }}</li>
                  <li><i *ngIf="selectedStudyClassId === cls.id" class="fa fa-check att-check-icon"></i></li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">Building Name</label>
        <div class="dropdown w-100">
          <a class="att-dialog-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="dropdown-text">{{ selectedBuildingName || 'Select Building Name' }}</span>
          </a>
          <ul class="dropdown-menu w-100 att-dialog-dropdown-menu">
            <li class="att-search-container">
              <input type="text" class="form-control att-search-input" placeholder="Search Building"
                [(ngModel)]="buildingQuery" (keyup)="filterBuildings()" />
            </li>
            <li class="list_campus">
              <ng-container *ngFor="let b of filteredBuildingList">
                <ul class="att-dropdown-item" (click)="selectBuilding(b)"
                  [class.att-item-selected]="selectedBuildingId === b.id">
                  <li class="att-item-text">{{ b.name }}</li>
                  <li><i *ngIf="selectedBuildingId === b.id" class="fa fa-check att-check-icon"></i></li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>

      <div class="att-dialog-field">
        <label class="att-dialog-label">Section</label>
        <div class="dropdown w-100">
          <a class="att-dialog-dropdown dropdown-toggle w-100 d-flex align-items-center justify-content-between"
            role="button" data-bs-toggle="dropdown" aria-expanded="false"
            [class.att-dialog-dropdown-empty]="noSectionFound">
            <span class="dropdown-text" [class.att-no-section]="noSectionFound">
              {{ selectedSectionName || (noSectionFound ? 'No Section' : 'Select Section') }}
            </span>
          </a>
          <ul class="dropdown-menu w-100 att-dialog-dropdown-menu">
            <li class="att-search-container" *ngIf="!noSectionFound">
              <input type="text" class="form-control att-search-input" placeholder="Search Section"
                [(ngModel)]="sectionQuery" (keyup)="filterSections()" />
            </li>
            <li class="list_campus">
              <div class="att-dd-empty" *ngIf="noSectionFound || !filteredSectionList?.length">No Section</div>
              <ng-container *ngFor="let s of filteredSectionList">
                <ul class="att-dropdown-item" (click)="selectSection(s)"
                  [class.att-item-selected]="selectedSectionId === s.id">
                  <li class="att-item-text">{{ s.sectionName}} - {{s.id}}</li>
                  <li><i *ngIf="selectedSectionId === s.id" class="fa fa-check att-check-icon"></i></li>
                </ul>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="att-dialog-actions">
    <button type="button" class="att-dialog-btn att-dialog-btn-search" (click)="apply()"
      [disabled]="!isFilterComplete">Search</button>
  </div>
</div>
